import React from "react"
import { Mask, Screen } from "./PreStyledComponents"

export const MobileSkulkAnimation = () => (
  <Screen className="dib dn-l skulk">
    <Mask />
  </Screen>
)

export const DesktopSkulkAnimation = () => (
  <Screen className="dn dib-l screen-large skulk-large">
    <Mask className="mask-large" />
  </Screen>
)
